@let currentField = getCurrentField();
@let color = currentColor();
@let boxStyle = currentStyle();
@let blocked = isBlocked();
@let isDefault = type() === cardTypes.DEFAULT;

<card-base
    [field]="field()"
    [favoriteField]="favoriteField()"
    [trashField]="trashField()"
    [type]="type()"
    [disabled]="blocked"
    [selected]="selected()"
    [block]="true">

    <!-- Zona 1 do rail: "Aparência", com a cor (bolinhas lado a lado) e o estilo da
         caixa (miniaturas na cor atual) no mesmo menu. -->
    <div
        card-toolbar
        class="color-chip-wrapper">
        @if (isDefault) {
            <button
                type="button"
                class="color-chip"
                [class.open]="look.isOpen()"
                [class.default-disabled]="blocked"
                [attr.aria-label]="'document.edit.railLook.appearance' | translate"
                [raEditTooltip]="look.isOpen() ? null : { text: ('document.edit.railLook.appearance' | translate), position: 'left' }"
                [raLookPanel]="lookTpl"
                lookPanelTitle="document.edit.railLook.appearance"
                [lookPanelItemId]="field()?._id"
                [lookPanelDisabled]="blocked"
                #look="lookPanel"
                (click)="look.toggle()">
                <ra-icon icon="palette" varColor="currentColor" [size]="22" />
            </button>

            <ng-template #lookTpl>
                <div class="look-panel-body">
                    <p class="look-title">{{ 'document.edit.railLook.color' | translate }}</p>
                    <div class="look-swatches">
                        @for (option of colorOptions; track option.key) {
                            <button
                                type="button"
                                class="look-swatch"
                                [class.current]="color.key === option.key"
                                [style.background-color]="option.accent"
                                [attr.aria-label]="option.labelKey | translate"
                                [attr.aria-pressed]="color.key === option.key"
                                [raEditTooltip]="{ text: (option.labelKey | translate), position: 'top' }"
                                (click)="selectColor(option.key)">
                            </button>
                        }
                        <custom-color-swatch
                            [value]="color.accent"
                            [current]="color.key === 'custom'"
                            [label]="'document.edit.calloutCard.colorCustom' | translate"
                            (preview)="colorPreview.set($event)"
                            (choose)="chooseCustomColor($event)" />
                    </div>

                    <span class="look-divider"></span>
                    <p class="look-title">{{ 'document.edit.calloutCard.style' | translate }}</p>
                    <div class="look-grid" style="--look-cols: 2">
                        @for (option of styleOptions; track option.key) {
                            <button
                                type="button"
                                class="look-option"
                                [class.current]="boxStyle === option.key"
                                (click)="selectStyle(option.key)">
                                <span
                                    aria-hidden="true"
                                    [class]="'style-glyph style-glyph-' + option.key"
                                    [style.--g-fill]="color.fill"
                                    [style.--g-accent]="color.accent"
                                    [style.--g-line]="color.line"></span>
                                <span>{{ option.labelKey | translate }}</span>
                            </button>
                        }
                    </div>
                </div>
            </ng-template>
        }
    </div>

    <!-- A caixa como imprime: fundo tonal, título em caixa alta, texto. -->
    <div
        class="callout"
        [class.callout-stripe]="boxStyle === 'stripe'"
        [class.callout-outline]="boxStyle === 'outline'"
        [class.callout-quote]="boxStyle === 'quote'"
        [style.--callout-ink]="color.ink"
        [style.--callout-fill]="color.fill"
        [style.--callout-accent]="color.accent"
        [style.--callout-line]="color.line"
        [style.font-family]="editDataService.documentFontFamily()">

        @if (isDefault) {
            <input
                type="text"
                class="callout-title"
                maxlength="80"
                autocomplete="off"
                spellcheck="true"
                [value]="currentField.name ?? ''"
                [disabled]="blocked"
                [placeholder]="'document.edit.calloutCard.titlePlaceholder' | translate"
                (keydown)="onTitleKeydown($event)"
                (change)="saveTitle($event)"
                (click)="$event.stopPropagation()"
            />
        } @else if (currentField.name) {
            <p class="callout-title-static">{{ currentField.name }}</p>
        }

        <!-- O texto é editado direto na caixa (salva em `description`); o tamanho vem da
             barra do topo e a cor é a da família, não do texto. -->
        @if (isDefault || hasText()) {
            <inline-text-editor
                class="callout-text"
                [field]="currentField"
                target="description"
                [placeholder]="'document.edit.calloutCard.textPlaceholder' | translate"
                [readonly]="!isDefault"
                [blocked]="blocked"
                [allowColor]="false" />
        }
    </div>
</card-base>
